import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { Dialog, IconButton, DialogTitle, DialogContent, Grid, TextField, Button, FormControlLabel, Checkbox } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { toast } from 'react-toastify'
import NumberFormat from 'react-number-format'

import './style.css'
import { Model } from '../../../models/model'

import { generalGetFormasPagosVentas, generalGetFormasPagos } from '../../../redux/actions/general'

export const DialogNewFormaPago = ({ open, setOpen, initialData, origen }) => {
    // console.log({ initialData })

    const dispatch = useDispatch()

    const [form, setForm] = useState({
        id: initialData.id,
        nombre: initialData.nombre,
        estado: initialData.estado,
        dias: initialData.dias,
        porcentaje: initialData.porcentaje,
        origen: origen
    })

    const handleSave = async () => {

        if (form.nombre === '') {
            toast.warn("Ingrese nombre")
            return false
        }

        let resultsFetch = null
        if (form.id > 0) {

            resultsFetch = await Model.update({
                url: `formas_pagos/from-params/${form.id}`,
                dataForm: form
            })

        } else {

            resultsFetch = await Model.save({
                url: 'formas_pagos',
                dataForm: form,
                resultData: true
            })

        }

        if (origen === 'ventas') {
            dispatch(generalGetFormasPagosVentas(resultsFetch))
        } else {
            dispatch(generalGetFormasPagos(resultsFetch))
        }

        setOpen(false)

    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const handleChecked = ({ target }) => {
        setForm({
            ...form,
            estado: target.checked
        })
    }

    const handleChangeNumbers = (data, targetName) => {
        const { floatValue } = data

        setForm({
            ...form,
            [targetName]: floatValue
        })
    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                {form.id > 0 ?
                    <div>Detalle Forma de pago <span className="text-uppercase">( {form.nombre} )</span></div>
                    :
                    `Nueva forma de pago ${form.nombre !== '' ? `( ${form.nombre} )` : ''}`
                }
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox style={{ color: '#8E24AA' }} checked={form.estado} />}
                            label="Habilitado"
                            onChange={handleChecked}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Forma de pago (*)"
                            name="nombre"
                            id="outlined-size-small"
                            value={form.nombre || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese nombre forma de pago'
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <div className='p-montos-mas-totales-2'>
                            <NumberFormat
                                customInput={TextField}
                                label="Cantidad días"
                                id="outlined-size-small"
                                size="small"
                                name="dias"
                                value={form.dias || 0}
                                onValueChange={(values, sourceInfo) => handleChangeNumbers({ ...values, sourceInfo }, 'dias')}
                                decimalScale={0}
                                fixedDecimalScale
                            />
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        <div className='p-montos-mas-totales-2'>
                            <NumberFormat
                                customInput={TextField}
                                label="Porcentaje facturación"
                                id="outlined-size-small"
                                size="small"
                                name="porcentaje"
                                value={form?.porcentaje || 0}
                                suffix='%'
                                onValueChange={(values, sourceInfo) => handleChangeNumbers({ ...values, sourceInfo }, 'porcentaje')}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} className="text-end">
                        <Button
                            id="id-button-save-ppto"
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            onClick={handleSave}
                            type='button'
                        >
                            {''}Guardar
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}